// export const backendHost = 'http://127.0.0.1:55572';
export const backendHost = 'https://partners.win777.online';